import type { TypeformConfig } from "./types";

export const TypeformConfigMap = {
  HOMEPAGE_CSAT: {
    // cspell:disable-next-line
    id: "Bv328u2G",
    key: "scmp-homepage-csat-typeform-is-shown",
    shouldAutoOpen: {
      desktop: false,
      mobile: false,
    },
    treatAsFinished: "onSubmit",
    variant: {
      sidetab: {
        buttonText: "Share your feedback",
        hideIcon: {
          desktop: false,
          mobile: true,
          tablet: true,
        },
      },
    },
  },
  PLUS_SURVEY_FOR_NON_PLUS_SUBSCRIBERS: {
    id: "mK5DfiUl",
    key: "scmp-plus-survey-for-non-plus-subscribers-typeform-is-shown",
    shouldAutoOpen: {
      desktop: false,
      mobile: false,
    },
    treatAsFinished: "onSubmit",
  },
  PLUS_SURVEY_FOR_PLUS_SUBSCRIBERS: {
    id: "UIlPK0Wm",
    key: "scmp-plus-survey-for-plus-subscribers-typeform-is-shown",
    shouldAutoOpen: {
      desktop: false,
      mobile: false,
    },
    treatAsFinished: "onSubmit",
  },
  READ_MORE_SURVEY: {
    // cspell:disable-next-line
    id: "Y25RZhCu",
    key: "scmp-econ-article-read-more-typeform-is-shown",
    shouldAutoOpen: {
      desktop: false,
      mobile: true,
    },
    treatAsFinished: "onSubmit",
  },
  SEARCH_RESULT: {
    // cspell:disable-next-line
    id: "nmaHYBYA",
    key: "scmp-search-result-typeform-is-shown",
    shouldAutoOpen: {
      desktop: true,
      mobile: false,
    },
    treatAsFinished: "onReady",
  },
} satisfies Record<string, TypeformConfig>;
